/* eslint-disable */
import { Button } from "@material-ui/core";
import { ElementsConsumer, PaymentElement } from "@stripe/react-stripe-js";
import React from "react";
import Loading from "react-fullscreen-loading";

class ChangeCardForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      success: false,
      msgError: "",
    };
  }

  loadingOff() {
    this.setState({ loading: false });
  }
  loadingOn() {
    this.setState({ loading: true });
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    const { stripe, elements, studentPlanId, successChange, setSuccessChange } = this.props;

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    const that = this;
    that.loadingOn();
    stripe
      .confirmSetup({
        elements,
        //clientSecret,
        confirmParams: {
          // Return URL where the customer should be redirected after the SetupIntent is confirmed.
          return_url: "https://lingofor.me",
        },
        redirect: "if_required",
      })
      .then(function (result) {
        if (result.error) {
          that.setState({
            success: true,
            msgError:
              result.error.message === "Your card is not supported." ? "CHANGE_CARD_ERROR" : result.error.message,
          });
          that.loadingOff();
        } else {
          if (result.setupIntent) {
            let status = result.setupIntent.status;
            if (status === "succeeded") {
              // Ja temos o payment_method, só mandar pra API
              let payment_method = result.setupIntent.payment_method;

              fetch(`${process.env.REACT_APP_LINK_API}/subscriptions-stripe/update-payment-method`, {
                //fetch("https://api-qas.lingofor.me/subscriptions-stripe/update-payment-method", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  studentPlanId: studentPlanId,
                  paymentMethodId: payment_method,
                }),
              })
                .then((res) => res.json())
                .then((res) => {
                  that.setState({ success: true });

                  that.loadingOff();
                  setSuccessChange(!successChange);
                })
                .then((res) => {
                  that.setState({ success: true });
                });
            }
          } else {
            that.setState({ success: true, msgError: "Houve um problema ao processar o cartão. Tente novamente." });
          }
        }
      });
  };

  render() {
    const { t } = this.props;
    return (
      <>
        <Loading loading={this.state.loading} background="rgba(0,0,0,0.6)" loaderColor="#3498db" />

        {!this.state.success ? (
          <form onSubmit={this.handleSubmit}>
            <PaymentElement />
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                marginTop: 12,
              }}
            >
              <Button type="submit" color="primary" autoFocus disabled={!this.props.stripe}>
                {t("SAVE")}
              </Button>
            </div>
          </form>
        ) : (
          <div className="flexDiv">
            {this.state.msgError !== "" ? (
              <p className="error">{t(this.state.msgError)}</p>
            ) : (
              <p className="success">{t("SUCCESS_CHANGE_CARD")}</p>
            )}
          </div>
        )}
      </>
    );
  }
}

export default function InjectedChangeCardForm(props) {
  const clientSecret = props.clientSecret;
  const studentPlanId = props.studentPlanId;
  const t = props.t;
  const { successChange, setSuccessChange } = props;

  return (
    <ElementsConsumer>
      {({ stripe, elements }) => (
        <ChangeCardForm
          stripe={stripe}
          elements={elements}
          clientSecret={clientSecret}
          studentPlanId={studentPlanId}
          t={t}
          successChange={successChange}
          setSuccessChange={setSuccessChange}
        />
      )}
    </ElementsConsumer>
  );
}
